import mapboxgl from 'mapbox-gl';
import AnimatedPopup from 'mapbox-gl-animated-popup';

const mapToken = 'pk.eyJ1IjoibGlldmVuZGVrZXkiLCJhIjoiY2wyb3V6bGs0MmYydDNrcWhxbDE5aHBmeiJ9.gug9G31hlZt6V-lMJbO7CA';
const mapStyle = 'mapbox://styles/lievendekey/cl2sp8mx7002q14pdkgvdr4ve';
const mapZoom = 11.5;
const mapCenter = [4.89931, 52.373792];
const mapBounds = [
  [4.15, 52],
  [5.65, 52.75]
];

const customLayers = ['woningverbetering', 'nieuwbouw', 'onderhoud'];

mapboxgl.accessToken = mapToken;
const map = new mapboxgl.Map({
  container: 'map',
  style: mapStyle,
  center: mapCenter,
  zoom: mapZoom,
  maxBounds: mapBounds
});

map.addControl(
  new mapboxgl.FullscreenControl({
    container: document.querySelector('body'),
  }),
  'bottom-right'
);
map.addControl(
  new mapboxgl.NavigationControl({
    showCompass: false,
  }),
  'bottom-right'
);


// APP

map.on('load', (event) => {
  // Legenda show/hide on click
  let legendaClick = (btn) => {
    let btnDiv = btn.querySelector('div');
    let btnId = btnDiv.classList[0];

    if (btnDiv.classList.contains('btn-active')) {
      btnDiv.classList.remove('btn-active')
      map.setLayoutProperty(`${btnId}`, 'visibility', 'visible');
    } else {
      btnDiv.classList.add('btn-active')
      map.setLayoutProperty(`${btnId}`, 'visibility', 'none');
    }
  }
  const legendaBtns = document.querySelectorAll('#legenda ul li button');
  for (const legendaBtn of legendaBtns) {
    legendaBtn.onclick = function () { legendaClick(legendaBtn) };
  }

  // LIEVEN DE KEY
  const lievenDeKey = {
    type: 'FeatureCollection',
    features: [{
      type: 'Feature',
      properties: {
        message: 'Lieven de Key',
        iconSize: 1,
      },
      geometry: {
        type: 'Point',
        coordinates: [4.921063, 52.367457],
      },
    },],
  };
  for (const marker of lievenDeKey.features) {
    const el = document.createElement('div');
    el.className = 'marker dekey-icon';
    el.style.backgroundSize = 'cover';
    el.style.width = '42px';
    el.style.height = '42px';
    el.style.borderRadius = '100%';

    new mapboxgl.Marker(el)
      .setLngLat(marker.geometry.coordinates)
      .addTo(map);
  }

  // POPUPS
  customLayers.forEach(layer => {
    map.on('click', layer, (e) => {
      let feature = e.features[0];
      let img = feature.properties.place_img;
      let name = feature.properties.place_name;
      let txt = feature.properties.place_txt;
      let link = feature.properties.place_link;
      let cat = feature.properties.place_cat;

      const popupOffset = 25;

      let popUp = `<div class="${cat} popup-container">
                    ${img ? `<img src="${img}">` : ''}
                    <div class="popup-copy">
                      ${name ? `<h3>${name}</h3>` : ''}
                      ${txt ? `<p>${txt}</p>` : ''}
                    </div>
                    ${link ? `<div class="popup-btn"><a href="${link}" target="_blank"><div class="popup-link">Meer informatie</div></a></div>` : ''}
                  </div>`;

      new mapboxgl.Popup({
        offset: popupOffset
      })
        .setLngLat(feature.geometry.coordinates)
        .setHTML(popUp)
        .addTo(map);
    })
    // Change the cursor to a pointer when the mouse is over the places layer.
    map.on('mouseenter', layer, () => {
      map.getCanvas().style.cursor = 'pointer';
    });
    // Change it back to a pointer when it leaves.
    map.on('mouseleave', layer, () => {
      map.getCanvas().style.cursor = '';
    });
  })
});